import type { ErrorMap } from '@/app/error-registry';

export const PROJECT_FILE_UPLOAD_ERROR_MAP: ErrorMap = {
  POST: {
    'File.TooLarge': 'projectFiles:apiErrors.uploadFileTooLarge',
    'File.InvalidType': 'projectFiles:apiErrors.uploadInvalidType',
    forbidden: 'projectFiles:apiErrors.uploadForbidden',
    default: 'projectFiles:apiErrors.uploadFailed',
  },
};

export const PROJECT_FILE_DELETE_ERROR_MAP: ErrorMap = {
  DELETE: {
    'File.NotFound': 'projectFiles:apiErrors.deleteNotFound',
    forbidden: 'projectFiles:apiErrors.deleteForbidden',
    default: 'projectFiles:apiErrors.deleteFailed',
  },
};

export const PROJECT_FILE_MOVE_ERROR_MAP: ErrorMap = {
  PUT: {
    'File.NotFound': 'projectFiles:apiErrors.moveFileNotFound',
    'Folder.NotFound': 'projectFiles:apiErrors.moveFolderNotFound',
    forbidden: 'projectFiles:apiErrors.moveForbidden',
    default: 'projectFiles:apiErrors.moveFailed',
  },
};

export const PROJECT_FOLDER_CREATE_ERROR_MAP: ErrorMap = {
  POST: {
    'Folder.NameAlreadyExists': 'projectFiles:apiErrors.folderNameTaken',
    forbidden: 'projectFiles:apiErrors.folderCreateForbidden',
    default: 'projectFiles:apiErrors.folderCreateFailed',
  },
};

export const PROJECT_FOLDER_DELETE_ERROR_MAP: ErrorMap = {
  DELETE: {
    'Folder.NotEmpty': 'projectFiles:apiErrors.folderNotEmpty',
    'Folder.NotFound': 'projectFiles:apiErrors.folderNotFound',
    forbidden: 'projectFiles:apiErrors.folderDeleteForbidden',
    default: 'projectFiles:apiErrors.folderDeleteFailed',
  },
};

export const PROJECT_FOLDER_RENAME_ERROR_MAP: ErrorMap = {
  PUT: {
    'Folder.NameAlreadyExists': 'projectFiles:apiErrors.folderNameTaken',
    'Folder.NotFound': 'projectFiles:apiErrors.folderNotFound',
    forbidden: 'projectFiles:apiErrors.folderRenameForbidden',
    default: 'projectFiles:apiErrors.folderRenameFailed',
  },
};

export const PROJECT_FOLDER_MOVE_ERROR_MAP: ErrorMap = {
  PUT: {
    'Folder.CircularReference': 'projectFiles:apiErrors.folderCircularReference',
    'Folder.NotFound': 'projectFiles:apiErrors.folderNotFound',
    forbidden: 'projectFiles:apiErrors.folderMoveForbidden',
    default: 'projectFiles:apiErrors.folderMoveFailed',
  },
};

export const PROJECT_FILE_FAVORITE_ERROR_MAP: ErrorMap = {
  PUT: {
    'File.NotFound': 'projectFiles:apiErrors.favoriteNotFound',
    forbidden: 'projectFiles:apiErrors.favoriteForbidden',
    default: 'projectFiles:apiErrors.favoriteFailed',
  },
};

export const PROJECT_FILE_RENAME_ERROR_MAP: ErrorMap = {
  PUT: {
    'File.NotFound': 'projectFiles:apiErrors.renameNotFound',
    'File.NameConflict': 'projectFiles:apiErrors.renameConflict',
    forbidden: 'projectFiles:apiErrors.renameForbidden',
    default: 'projectFiles:apiErrors.renameFailed',
  },
};

export const PROJECT_FILE_VISIBILITY_ERROR_MAP: ErrorMap = {
  PUT: {
    'File.NotFound': 'projectFiles:apiErrors.visibilityNotFound',
    forbidden: 'projectFiles:apiErrors.visibilityForbidden',
    default: 'projectFiles:apiErrors.visibilityFailed',
  },
};

export const PROJECT_FILE_BULK_DELETE_ERROR_MAP: ErrorMap = {
  DELETE: {
    forbidden: 'projectFiles:apiErrors.bulkDeleteForbidden',
    default: 'projectFiles:apiErrors.bulkDeleteFailed',
  },
};
